import api from '../../api/document.api';

export function fetchDocuments() {
  return () => {
    return api.fetchDocuments()
        .then(response => response.result)
        .catch(error => Promise.reject(error));
  };
}
